import { FoodBrand, FoodName, StyledNameAndPortion } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import FutureMealIcon from "components/Icons/FutureMealIcon"
import PortionOnlyFormItem from "components/portion/PortionOnlyFormItem"
import { OpenFoodFactEntry } from "model/food/types"

interface IProps {
  food: OpenFoodFactEntry
  portionValue: number
  onPortionChange: (portion: number) => void
  unitValue: string
  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
  gram: null | number
  isFutureScheduleMeal?: boolean
}

const OpenFoodFactNameAndPortion = (props: IProps) => {
  const {
    food,
    onPortionChange,
    portionValue,
    unitValue,
    setIsPortionValid,
    calories,
    gram,
    isFutureScheduleMeal,
  } = props

  return (
    <StyledNameAndPortion>
      <FlexBox
        $alignItems="center"
        $gap={8}
        style={{ padding: "4px 0", width: "100%" }}
      >
        <FoodName>{food.name}</FoodName>
        {isFutureScheduleMeal && <FutureMealIcon />}
      </FlexBox>

      {food.brand ? <FoodBrand>{food.brand}</FoodBrand> : null}

      <PortionOnlyFormItem
        unit={unitValue}
        portionValue={portionValue}
        onPortionChange={onPortionChange}
        setIsPortionValid={setIsPortionValid}
        calories={calories}
        gram={gram}
      />
    </StyledNameAndPortion>
  )
}

export default OpenFoodFactNameAndPortion
